// Run on load 
document.addEventListener("DOMContentLoaded", function () {
    initMobileHeaderButtons();

    if (window.innerWidth >= 960) {
        document.querySelectorAll(".page-template-default-product-pricing thead th button").forEach(function (btn) {
            btn.classList.remove("active");
        });
    }

    if (window.innerWidth <= 960) {
        document.querySelectorAll(".page-template-default-product-pricing tbody tr").forEach(function (row) {
            const cells = row.querySelectorAll("td");
            if (cells.length >= 4) {
                cells[2].style.display = "none"; // 3rd <td>
                cells[3].style.display = "none"; // 4th <td>
            }
        });
    }

    tabSwitchClick();
});



//Tab switch code 
function initMobileHeaderButtons() {
    const buttons = document.querySelectorAll(".page-template-default-product-pricing .table-wrapper th button");
    if (!buttons.length) return;

    // Remove old listeners if needed
    buttons.forEach(btn => {
        btn.replaceWith(btn.cloneNode(true));
    });

    const freshButtons = document.querySelectorAll(".page-template-default-product-pricing .table-wrapper th button");
    if (window.innerWidth <= 960) {
        freshButtons.forEach(btn => {
            btn.addEventListener("click", () => {
                // Remove active class from all
                freshButtons.forEach(b => b.classList.remove("active"));
                // Add active to the clicked one
                btn.classList.add("active");
            });
        });
    }
}


//table data hide and show basis of tab
function tabletabChange(colClass = "premium") {
    // remove active class from all buttons

    // add active to the button of selected column
    let activeTh = document.querySelector(`.page-template-default-product-pricing thead th.${colClass} button`);
    if (activeTh) activeTh.classList.add("active");

    // hide all td
    document.querySelectorAll(".page-template-default-product-pricing tbody td").forEach(td => td.style.display = "none");

    // always show first column (Features)
    document.querySelectorAll(".page-template-default-product-pricing tbody tr td:first-child").forEach(td => td.style.display = "");

    // show selected column by class
    document.querySelectorAll(`.page-template-default-product-pricing tbody td.${colClass}`).forEach(td => td.style.display = "");

    // optional: handle fallback in case td class not present
    if (colClass === "premium") {
        document.querySelectorAll(".page-template-default-product-pricing tbody tr td:nth-child(2)").forEach(td => td.style.display = "");
    } else if (colClass === "standard") {
        document.querySelectorAll(".page-template-default-product-pricing tbody tr td:nth-child(3)").forEach(td => td.style.display = "");
    } else if (colClass === "advanced") {
        document.querySelectorAll(".page-template-default-product-pricing tbody tr td:nth-child(4)").forEach(td => td.style.display = "");
    }

}

// attach to click events
function tabSwitchClick() {
    document.querySelectorAll(".page-template-default-product-pricing thead th").forEach(button => {

        if (window.innerWidth <= 960) {
            button.addEventListener("click", function () {
                let colClass = this.closest("th").className;
                tabletabChange(colClass);
            });
        }
    });
}

document.addEventListener("DOMContentLoaded", () => {
    const toggleBtn = document.querySelector(".page-template-default-product-pricing .toggle-btn");
    const body = document.body;

    if (!toggleBtn) return; // stop if element not found

    toggleBtn.textContent = "🌙";

    toggleBtn.addEventListener("click", () => {
        body.classList.toggle("dark");
        toggleBtn.textContent = body.classList.contains("dark") ? "☀️" : "🌙";
    });
});
